var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecyclables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13227_36366)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13227_36366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.333 10.667V40.6963H11.667V10.667H42.333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13227_36366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.123 31.6797H39.0361C39.385 31.6797 39.7199 31.6489 40.041 31.5908L36.833 37.1748C36.6233 37.5316 36.2394 37.7597 35.75 37.7598H31.123V38.623L28.7725 34.7021L31.123 30.7793V31.6797ZM25.2637 31.6094V37.7598H19.7686C18.2054 37.7598 16.9151 36.4669 16.915 34.9062C16.915 34.7144 16.9598 34.4123 17.0518 34.0781C17.1201 33.8297 17.2068 33.5915 17.3008 33.3945L17.3975 33.2119L17.4033 33.2002L18.2969 31.6094H25.2637ZM20.2246 25.8555L20 25.7266L19.4238 25.3955L19.0908 25.9707L15.4678 32.2373L15.4629 32.2451C15.3115 32.5153 15.1712 32.8394 15.0566 33.1768L11.8135 27.5947C11.7318 27.4526 11.667 27.2308 11.667 27.0488C11.667 26.8558 11.7394 26.5994 11.8125 26.4746L11.8154 26.4688L13.8477 22.9121L14.1797 22.3311L13.5977 22.001L13.4502 21.917L17.9922 21.833L20.2246 25.8555ZM41.7061 25.251C41.9621 25.7068 42.0928 26.1673 42.0928 26.6455C42.0926 27.6104 41.4527 28.6807 40.5723 29.1758C40.1725 29.387 39.5779 29.5352 38.9658 29.5352H37.1152L33.6494 23.5381L38.957 20.5088L41.7061 25.251ZM22.2734 10.9902C23.4026 10.9902 24.2798 11.4883 24.9492 12.626L24.9512 12.6299L25.9014 14.2217L22.4375 20.2139L17.125 17.124L19.8711 12.3857L19.8721 12.3838C20.3978 11.4714 21.2294 10.9904 22.2734 10.9902ZM32.5332 10.6865C33.074 10.6865 33.4158 10.8953 33.6172 11.2383V11.2373L35.6816 14.7578L36.0205 15.335L36.5967 14.9941L36.709 14.9277L34.5137 18.8623L30.0264 18.7988L30.1533 18.7275L30.7363 18.3965L30.4023 17.8154L26.7822 11.5156L26.5898 11.1816H26.5713C26.4541 11.0067 26.3291 10.8417 26.1973 10.6865H32.5332Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13227_36366",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13227_36366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13227_36366",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecyclables);
export default __webpack_public_path__ + "static/media/Recyclables.ccdde21e12ed525976be42320bfb81e7.svg";
export { ForwardRef as ReactComponent };